<div class="job-image-gallery-header">
    <h4 class="job-detail-title">{{ imageGalleryHeader | translate }}</h4>
    <a class="view-all-link" (click)="onViewAll()" *ngIf="images?.length > previewImageCount">{{
        'TC.Common.ViewAll' | translate
    }}</a>
</div>

<loading *ngIf="loading"></loading>
<div class="job-image-gallery-list" *ngIf="!loading">
    <div class="no-data-label error-label" *ngIf="error">
        <i class="i24 icon_solid_alert_critical_24"></i>
        {{ 'TCW.UserProfile.Error.WhileFetching' | translate }}
    </div>
    <div class="no-data-label" *ngIf="!error && !images?.length">
        {{ 'Survey.SurveyJobPanel.JobDetails.Attachments.NoJobImages' | translate }}
    </div>

    <ng-container>
        <ng-container *ngIf="!error">
            <ng-container *ngFor="let img of previewImages; let i = index">
                <div class="gallery-thumb" (click)="openLightboxAt(i)">
                    <img [src]="img.url" class="gallery-thumb-img" />
                </div>
            </ng-container>
            <div
                *ngIf="extraCount"
                class="gallery-thumb gallery-thumb-more"
                (click)="openLightboxAt(previewImageCount)"
            >
                +{{ extraCount }}
            </div>
        </ng-container>

        <!-- gallery modal/lightbox purposes -->
        <div class="gallery-init hidden">
            <image-field [field]="allJobImages" [thumbnailSwitchOn]="false" [galleryRef]="galleryRef"></image-field>
        </div>
    </ng-container>
</div>
